import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('CaseSubname').create(({ theme }) => ({
  root: {
    display: 'flex',
    gap: '4px',
    justifyContent: 'flex-start',
    color: theme.colors.text.primary,
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.xs,
    textWrap: 'nowrap',
    fontWeight: 350,
  },
  type: {
    '&[data-type="Standard Case"]': {
      color: theme.colors.text.secondary,
      fontWeight: 300,
    },
    '&[data-type="Special Event"]': {
      fontSize: '12px',
      fontWeight: 300,
    },
  },

  timeLimitation: {
    '&[data-timelimitation="Limited"]': {
      color: theme.colors.text.error,
    },
  },

  rarity: {
    '&[data-caserarity="Rare"]': {
      color: theme.colors.borders.rare,
    },
    '&[data-caserarity="Uncommon"]': {
      color: theme.colors.borders.uncommon,
    },
    '&[data-caserarity="Epic"]': {
      color: theme.colors.borders.epic,
    },

    '&[data-caserarity="Legendary"]': {
      color: theme.colors.borders.legendary,
    },
  },
}))
